import {
  Caption1,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import type { DeviationDetail } from '@lg/core';
import { SECTIONS } from '@lg/shared';

const useStyles = makeStyles({
  table: { tableLayout: 'auto' },
  lines: { margin: 0, paddingLeft: tokens.spacingHorizontalL },
  template: { color: tokens.colorNeutralForeground3 },
  reason: { color: tokens.colorNeutralForeground2, fontStyle: 'italic' },
});

const sectionTitle = new Map<string, string>(SECTIONS.map((s) => [s.id, s.title]));

function Lines({ lines, className }: { lines: string[]; className?: string }) {
  const styles = useStyles();
  if (lines.length <= 1) return <span className={className}>{lines[0] ?? '—'}</span>;
  return (
    <ul className={`${styles.lines} ${className ?? ''}`}>
      {lines.map((l) => (
        <li key={l}>{l}</li>
      ))}
    </ul>
  );
}

/**
 * Every answer that differs from the template, side by side: what the template has, what this
 * venue gets instead (one line per ledger overlay) and the requester's reason. Shown on the review
 * step, the Answers tab and at gate 2.
 */
export function DeviationTable({ details }: { details: DeviationDetail[] }) {
  const styles = useStyles();
  return (
    <Table size="small" className={styles.table} aria-label="Differences from the template">
      <TableHeader>
        <TableRow>
          <TableHeaderCell>What</TableHeaderCell>
          <TableHeaderCell>Template</TableHeaderCell>
          <TableHeaderCell>This venue</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {details.map((d) => (
          <TableRow key={d.key}>
            <TableCell>
              {d.label}
              <br />
              <Caption1>{sectionTitle.get(d.section) ?? d.section}</Caption1>
            </TableCell>
            <TableCell>
              <Lines lines={d.template} className={styles.template} />
            </TableCell>
            <TableCell>
              <Lines lines={d.request} />
              {d.reason && <div className={styles.reason}>Reason: {d.reason}</div>}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
